import React, { useState, useEffect } from 'react';

const VideoPlayer = ({ videoUrl, title = "Topic name", description = "Description about the video" }) => {
  const [videoId, setVideoId] = useState('');
  
  // Extract YouTube video ID from URL
  useEffect(() => {
    if (videoUrl) {
      const match = videoUrl.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
      if (match && match[1]) {
        setVideoId(match[1]);
      }
    }
  }, [videoUrl]);

  return (
    <div className="flex flex-col w-full">
      {/* Title with exact Figma specs */}
      <div className="text-neutral-900 text-3xl font-bold capitalize leading-10 mb-2">
        {title}
      </div>
      
      {/* Description with exact Figma specs */}
      <div className="text-neutral-900 text-base font-normal leading-normal mb-4">
        {description}
      </div>
      
      {/* Video container with proper dimensions */}
      <div className='w-full flex justify-center items-center'>
        <div className="relative w-[1274px] max-w-full bg-black rounded-xl overflow-hidden aspect-video">
          {videoId ? (
            <iframe 
              width="100%" 
              height="100%" 
              src={`https://www.youtube.com/embed/${videoId}?controls=1`}
              title={title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-800 text-white">
              Video source not available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;